module.exports = {"id":"137410","name":"Daniele Gastaldello","rating":"74","photo":"./data/images/photos/1/137410.png","club":{"name":"Brescia","logo":"./data/images/clubs/Brescia.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DanieleGastaldello0.json
// module id = 948
// module chunks = 0